import { render, staticRenderFns } from "./MissionSugoIcon.vue?vue&type=template&id=35187875&scoped=true"
import script from "./MissionSugoIcon.vue?vue&type=script&lang=js"
export * from "./MissionSugoIcon.vue?vue&type=script&lang=js"
import style0 from "./MissionSugoIcon.vue?vue&type=style&index=0&id=35187875&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35187875",
  null
  
)

export default component.exports